import { h } from "hyperapp";
import { Portifolios } from "../../common/portifolios/main";

export const controls = ({
  translations,
  actions: {
    fetchPortifolios,
    fetchUnvisitedPlacesNearby,
    setPortifolio,
    setRadius,
    setUnvisitedPlacesNearbybyQueryStringData,
  },
  section,
  state: {
    category,
    clientID,
    coordinates,
    loadingPortifolios,
    loadingUnvisitedPlacesNearby,
    name,
    pageNumber,
    pageSize,
    portifolioID,
    portifolios,
    radius,
    since,
  },
}): JSX.Element => {
  return (
    <form
      key="unvisitedPlacesNearbyControls"
      oncreate={() => setUnvisitedPlacesNearbybyQueryStringData()}
      onsubmit={event => (
        event.preventDefault(),
        fetchUnvisitedPlacesNearby({
          categoryID: category.id,
          clientID,
          coordinates,
          pageNumber,
          pageSize,
          radius,
          since,
        })
      )}
    >
      <div class="align-items-start justify-content-start align-items-md-end justify-content-md-end d-flex flex-column flex-md-row flex-md-wrap flex-lg-column">
        <div class="col-12 col-md-4 col-lg-12 d-md-inline-block mb-3 p-0 pr-md-2 pr-lg-0">
          <label for="since">{translations["withoutVisitsSince"]}</label>
          <input
            class="form-control"
            id="since"
            readonly
            type="date"
            value={since}
          />
        </div>
        <div class="col-12 col-md-4 col-lg-12 d-md-inline-block mb-3 p-0 pl-md-2 pl-lg-0">
          <label for="timespan">{translations["fromCategory"]}</label>
          <input
            class="form-control"
            id="timespan"
            readonly
            type="text"
            value={category.name || "Todas as categorias"}
          />
        </div>
        {Portifolios({
          translations,
          actions: { setPortifolio, fetchPortifolios },
          section,
          state: {
            clientID,
            disabled: loadingUnvisitedPlacesNearby,
            loading: loadingPortifolios,
            portifolioID,
            portifolios,
          },
        })}
        <div class="col-12 col-md-4 col-lg-12 d-md-inline-block mb-3 p-0 pl-md-2 pl-lg-0">
          <label for="radius">{translations["withinA"]}</label>
          <select
            class="custom-select"
            disabled={loadingUnvisitedPlacesNearby}
            id="radius"
            onblur={event => setRadius({ radius: event.target.value })}
            value={radius}
          >
            <option value="1000">1 km</option>
            <option value="5000">5 km</option>
            <option value="10000">10 km</option>
            <option value="50000">50 km</option>
            <option value="100000">100 km</option>
          </select>
        </div>
        <div class="col-12 col-md-4 col-lg-12 d-md-inline-block mb-3 p-0 pl-md-2 pl-lg-0">
          <label for="near">{translations["FromLocation"]}</label>
          <input
            class="form-control"
            id="near.name"
            type="text"
            readonly
            value={name}
          />
          <input
            class="form-control"
            hidden
            id="near.coordinates"
            type="text"
            readonly
            value={coordinates}
          />
        </div>
        <div class="col-12 col-md-4 col-lg-12 d-md-inline-block mb-3 p-0 pl-md-2 pl-lg-0">
          <button
            class="btn btn-outline-primary form-control"
            disabled={loadingUnvisitedPlacesNearby}
            type="submit"
          >
            {translations["search"]}
          </button>
        </div>
      </div>
    </form>
  );
};
